import React from 'react'
import './App.css';
import Home from './Component/Home';

function App() {
  return (
    <div className="App">
      <Home />
      {/* <Demo /> */}
    </div>
  );
}

export default App;
